import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import ModalCargando from "./Modules/Cargando";
import Login from "./Modules/Login";
import Intro from "./Modules/Intro";
import Teoria from "./Modules/Teoria"; 	
import Exploracion from "./Modules/Exploracion";
import Final from "./Modules/Final";
import Menu from "./Modules/Menu";
import "./App.scss";

function mapStateToProps(state) {
	return{
		usuario: state.login,
		pagina: state.navegacion.pagina,
	};
}

class AppConected extends Component {
	static propTypes = {
		usuario:PropTypes.object,
		pagina:PropTypes.string,
	}
	
	componentDidMount(){
		document.getElementById("root").style.display = "block";
	}
  
	render() {
		let content = null;
		switch(this.props.pagina){
		case "inicio":
			content = <Intro/>;
			break;
		case "teoria":
			content = <Teoria/>;
			break;
		case "exploracion":
			content = <Exploracion/>;
			break;
		case "final":
			content = <Final/>;
			break;
		default:
			content = <div>Undefined</div>;
			break;
		}
		return(
			<div className="App">
				<ModalCargando/>
				<header>
					<a href="https://vinnospain.com/" id="link-vinn" target="_new">
						<div id="l-vinno"></div>
					</a>
				</header>
				<div className="main">
					{this.props.usuario.user === ""? (
						<Login/>
					): (<>
						<Menu/>
						<div className="content">{content}</div>
					</>)}
				</div>
				<footer>
					<div id="avisoPoli">
							Copyright© VINNO Ultrasound S.L.U.. Todos los derechos reserevados
						<div id="avisoPoliIn">
							<a href="https://cursoecografiavinno.com/politica-de-privacidad/" target="_new"> Política de privacidad </a> | <a href="https://cursoecografiavinno.com/aviso-legal/" target="_new"> Aviso legal </a>
						</div>
					</div>
					<div id="powerBy">
						<a href="https://vinnospain.com/" target="_new">
							<div id="logo_powered"></div>
						</a>
					</div>
				</footer>
			</div>
		);
	}
}

const App = connect(mapStateToProps)(AppConected);
export default App ;
